import { Button } from "@material-ui/core";
import { FieldArray, Form, Formik } from "formik";
import React from "react";
import styled from "styled-components";
import IWPPWorkflowStep from "./IWPPWorkflowStep";
import IWPPWorkflowStepReadOnly from "./IWPPWorkflowStepReadOnly";

const ContainerFooter = styled.div`
  width: 100%;
  display: flex;
  height: 40px;
  justify-content: flex-end;
  padding-right: 20px;
`;

const ButtonContainer = styled.div`
  padding: 20px;
`;

const IWPPWorkflowForm = ({ initialValues, context }) => (
  <div>
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values) =>
        setTimeout(() => {
          alert(JSON.stringify(values, null, 2));
        }, 500)
      }
      
      render={(formProps) => (
        <Form>
          <FieldArray
            name="workflowSteps"
            render={(arrayHelpers) => (
              <>
                {formProps.values.workflowSteps && (
                  <>
                    {formProps.values.workflowSteps.map((workflowStep, index) =>
                      context.editingIWPPApprovers ? (
                        <IWPPWorkflowStep
                          key={index}
                          formProps={formProps}
                          arrayHelpers={arrayHelpers}
                          index={index}
                        />
                      ) : (
                        <IWPPWorkflowStepReadOnly
                          key={index}
                          formProps={formProps}
                          arrayHelpers={arrayHelpers}
                          index={index}
                        />
                      )
                    )}

                    {context.editingIWPPApprovers && (
                      <>
                        {formProps.values.workflowSteps.length < 5 && (
                          <ButtonContainer>
                            <Button
                              onClick={() => {
                                arrayHelpers.push({
                                  id: 0,
                                  stepLabel: null,
                                  proxy: null,
                                  primary: null,
                                });
                              }}
                            >
                              + Add IWPP Approver
                            </Button>
                          </ButtonContainer>
                        )}
                        <ContainerFooter>
                          <ButtonContainer>
                            <Button
                              onClick={() => {
                                formProps.resetForm();
                                context.editIWPPApprovers(false);
                              }}
                            >
                              Cancel
                            </Button>
                          </ButtonContainer>
                          <ButtonContainer>
                          <Button disabled={formProps.values.workflowSteps.some(bl=>!bl.primary && !bl.proxy)}
                            // <Button disabled="false"
                              onClick={() => {
                                context.updateIWPPWorkflowApprovers(
                                  formProps.values,
                                  0,
                                  (success) => {
                                    if (success) {
                                      context.editIWPPApprovers(false);
                                      formProps.resetForm();
                                    }
                                  }
                                );
                              }}
                            >
                              Save
                            </Button>
                          </ButtonContainer>
                        </ContainerFooter>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          />
        </Form>
      )}
    />
  </div>
);

export default IWPPWorkflowForm;
